import './dictProposalActionSummary.scss';
import { DictProposalActionSummaryProps } from "./types/dictProposalActionSummaryProps";
import { ReactComponent as AddNotes } from "../../../../../icons/add_notes.svg";
import Modal from '../../../../../components/modalWindow/modal';
import { classNameBtn } from '../../../../../components/shared/button/types/buttonProps';
import { getDictionaryProposalOverview } from '../../../../../helpers/dictionaryProposals';
import { DictProposalActions } from '../types/manageDictProposalsProps';
import ButtonField from '../../../../../components/buttonField/buttonField';

const DictProposalActionSummary = (props: DictProposalActionSummaryProps) => {
    const handleClose = () => {
        props.onClose();
    }
    
    const renderSummary = () => {
        var overview = getDictionaryProposalOverview(props.data);
        
         return <table>
            {overview?.map((item, index) => {
                return <tr key={index} style={{height: "50px"}}><td>{item.dictName}</td><td>{item.description}</td></tr>
            })}
        </table>
    }

    return (<Modal
        title={`${props.action === DictProposalActions.Approve ? "Zatwierdzone" : "Odrzucone"} propozycje słownikowe`}
        titleIcon={AddNotes}
        width='700px'
        height='430px'
        actionBtns={[
            <ButtonField
                key={1}
                BtnProps={{
                    onClick: handleClose,
                    className: `${classNameBtn.Btn} ${classNameBtn.Large} body-txt-medium`
                }}
                placeHolder="Zamknij"
            />
        ]}
        onClose={handleClose}>
        <div className="dictProposalActionSummaryContainer">
            { renderSummary() }
        </div>
    </Modal>);
};

export default DictProposalActionSummary;